import { Refine } from "@refinedev/core";
import { RefineKbar, RefineKbarProvider } from "@refinedev/kbar";
import { AuthenticatedLayout } from "./components/AuthenticatedLayout";
import DynamicFavicon from "./components/DynamicFavicon";

import { useNotificationProvider } from "@refinedev/antd";
import "@refinedev/antd/dist/reset.css";
import appTheme from "./theme.json";
import { TeamOutlined } from "@ant-design/icons";

import routerBindings, { UnsavedChangesNotifier } from "@refinedev/react-router";
import { App as AntdApp, ConfigProvider } from "antd";
import { BrowserRouter, Route, Routes, Navigate } from "react-router";
import { authProvider } from "./providers/authProvider";
import { i18nProvider } from "./providers/i18nProvider";
import { gmbhDataProvider, ggmbhDataProvider } from "./providers/dataProvider";
import { AuthRoutes } from "./features/auth/routes/AuthRoutes";
import { ConsultantListPage } from "./features/consultants/pages/ConsultantListPage";

function App() {
  const resourcesWithPages = [
    {
      name: "consultants",
      list: "/consultants",
      meta: {
        label: "Berater:innen",
        icon: <TeamOutlined />,
        url: "/berater-inner",
        page: <ConsultantListPage />,
      },
    },
  ];

  const resources = resourcesWithPages.map(({ meta: { page: _page, ...metaRest }, ...rest }) => ({
    ...rest,
    meta: metaRest,
  }));

  return (
    <BrowserRouter>
      <RefineKbarProvider>
        <DynamicFavicon />
        <AntdApp>
          <ConfigProvider theme={appTheme}>
            <Refine
              dataProvider={{
                default: gmbhDataProvider,
                ggmbh: ggmbhDataProvider,
              }}
              notificationProvider={useNotificationProvider}
              routerProvider={routerBindings}
              authProvider={authProvider}
              i18nProvider={i18nProvider}
              resources={resources}
              options={{
                syncWithLocation: true,
                warnWhenUnsavedChanges: true,
                useNewQueryKeys: true,
                projectId: "EvLL0t-2q0PWt-gFTsvf",
              }}
            >
              <Routes>
                <Route element={<AuthenticatedLayout />}>
                  <Route index element={<Navigate to="/berater-inner" replace />} />
                  {resourcesWithPages.map((resource) => (
                    <Route key={resource.name} path={resource.meta.url} element={resource.meta.page} />
                  ))}
                </Route>
                {AuthRoutes}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <RefineKbar />
              <UnsavedChangesNotifier />
            </Refine>
          </ConfigProvider>
        </AntdApp>
      </RefineKbarProvider>
    </BrowserRouter>
  );
}

export default App;
